import { render, staticRenderFns } from "./PlayHead.vue?vue&type=template&id=c0930ab0&scoped=true"
import script from "./PlayHead.vue?vue&type=script&lang=js"
export * from "./PlayHead.vue?vue&type=script&lang=js"
import style0 from "./PlayHead.vue?vue&type=style&index=0&id=c0930ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0930ab0",
  null
  
)

export default component.exports